import React from 'react';

export const LoadingOverlay = () => (
  <div className="cv-page-load">
    <span className="cv-page-load__sp" />
  </div>
);
